import { PAGINATION_QUERY_PAYLOAD } from "./payload";

const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
};

const { GET, POST, PUT } = HTTP_METHODS;

export const GENERIC_API_LIST = {
  create: { type: POST, urlPath: "create", hasAdditionalParams: true },
  edit: { type: PUT, urlPath: "edit", hasObjectId: true },
  get: { type: GET, urlPath: "", hasObjectId: true },
  delete: { type: POST, urlPath: "hard-delete" },
  getList: { type: POST, urlPath: "get-list", payload: PAGINATION_QUERY_PAYLOAD },
  getPaginatedList: {
    type: POST,
    urlPath: "get-paginated-list",
    payload: PAGINATION_QUERY_PAYLOAD,
  },
  keyValueList: { type: POST, urlPath: "key-value-list" },
  getPaginatesKeyValueList: {
    type: POST,
    urlPath: "get-paginated-key-value-list",
    payload: PAGINATION_QUERY_PAYLOAD,
  },
};
